import "../../../design/liveProjects.css";
import { liveProjectsArray } from "../../../helper/liveProjectsArray";
import { useState } from "react";
import LiveProjectModal from "../../modals/live_project_modals/LiveProjectsModal";
import { useDisclosure } from "@chakra-ui/react";

export default function LiveProjects() {
    const [project, setProject] = useState({});
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleOpen = (item) => {
        setProject(item);
        onOpen();
    };

    return (
        <div className="liveGallery">
            <div style={{ marginTop: '80px' }}></div>

            <div className="liveHeader">
                <div className="liveStatusIndicator"></div>
                <h1 className="liveTitleMain">Live</h1>
                <h1 className="liveTitleAccent">Projects</h1>
            </div>

            <div className="liveZigzagContainer">
                {liveProjectsArray.map((item, index) => (
                    <div key={index} className={`liveZigzagRow ${index % 2 !== 0 ? "liveRowReverse" : ""}`}>
                        <div className="liveZigzagNumber">{index + 1}</div>

                        <div className="liveZigzagText">
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                            <button className="liveActionBtn" onClick={() => handleOpen(item)}>
                                View Details
                            </button>
                        </div>

                        <div className="liveZigzagLine"></div>

                        <div className="liveZigzagImage" onClick={() => handleOpen(item)}>
                            <div className="liveImageContainer">
                                <img src={item.laptopImage} alt={item.title} />
                                <div className="liveOverlayContent">
                                    <span className="livePulseIcon"></span>
                                    VIEW PROJECT
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <LiveProjectModal isOpen={isOpen} onClose={onClose} project={project} />
        </div>
    );
}